module.exports = __webpack_public_path__ + "static/csr_hub-f1a51ec4733b1ddc425ba57d74d10cec.png";